import React, { useEffect } from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import DoorbelForm from '../components/buildings/DoorbellForm'
import useDoorbellsApi from '../hooks/doorbells/useDoorbellsApi'

export default function CreateDevicePage() {
  const history = useHistory()
  const location = useLocation()
  const [{ doorbellGroupsState }, doorbellsMethods] = useDoorbellsApi()

  const { buildingId, item, previousRoute, selectedTab, isGate } =
    location.state || {}

  useEffect(() => {
    const fetchData = async () => {
      doorbellsMethods.getDoorbellGroups(buildingId)
    }
    fetchData()
  }, [])

  return (
    <DoorbelForm
      buildingId={buildingId}
      onSubmit={(values) => {
        if (!isGate && !values.imageUpdated) {
          delete values.image
        }
        if (values.id) {
          doorbellsMethods.updateDoorbell({ ...values, buildingId }, true)
        } else {
          doorbellsMethods.createDoorbell({ ...values, buildingId }, true)
        }
        history.push(previousRoute, { selectedTab })
      }}
      handleCancel={() => history.push(previousRoute, { selectedTab })}
      doorbell={item}
      isGate={isGate}
      doorbellGroupsState={doorbellGroupsState}
    />
  )
}
